const STORE_RESET = 'OVID/STORE/RESET'

export const constants = {
  STORE_RESET,
}
